import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $b3nuO$useControlledState } from "@react-stately/utils";
function $587d3ad58be6d31f$export$daff6da51032a415() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _$b3nuO$useControlled = $b3nuO$useControlledState(props.value, props.defaultValue || [], props.onChange),
    _$b3nuO$useControlled2 = _slicedToArray(_$b3nuO$useControlled, 2),
    selectedValues = _$b3nuO$useControlled2[0],
    _setValue = _$b3nuO$useControlled2[1];
  var state = {
    value: selectedValues,
    setValue: function setValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      _setValue(value);
    },
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isSelected: function isSelected(value) {
      return selectedValues.includes(value);
    },
    addValue: function addValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (!selectedValues.includes(value)) _setValue(selectedValues.concat(value));
    },
    removeValue: function removeValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) _setValue(selectedValues.filter(function (existingValue) {
        return existingValue !== value;
      }));
    },
    toggleValue: function toggleValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) _setValue(selectedValues.filter(function (existingValue) {
        return existingValue !== value;
      }));else _setValue(selectedValues.concat(value));
    }
  };
  return state;
}
export { $587d3ad58be6d31f$export$daff6da51032a415 as useCheckboxGroupState };